import { Resolutions } from '@layout/domain/models/layout.models';

export enum TypeOfTemplate {
    MultiProductTemplate = 'MultiProductTemplate',
    SingleProductTemplate = 'SingleProductTemplate',
    DoubleProductTemplate = 'DoubleProductTemplate',
}
export interface ResolutionConfigResolver {
    useMobileConfig: Resolutions;
    mobile: number;
    desktop: number;
}

export type ColorSelectorType = 'selector' | 'square';
export interface ColorSelector {
    type: ColorSelectorType;
    colorsCount: number;
}
